import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { IMaskInput } from 'react-imask';
import { getInitConfig } from 'ziphy-web-shared';
import FieldWrapper from 'ziphy-web-shared/basic/lib/forms/fields/_components/FieldWrapper';
import { useFieldWrapper } from 'ziphy-web-shared/basic/lib/forms/fields/_components/FieldWrapper.hooks';
import { localStore } from 'ziphy-web-shared/basic/utils';
import { getPhoneConfigByAreaCode, getPhoneConfigByCountry, getPhoneConfigByInputValue, } from './PhoneInput.helpers';
import styles from './PhoneInput.module.scss';
import PhoneInputDropdown from './phoneInputDropdown/PhoneInputDropdown';
const PhoneInput = forwardRef((props, ref) => {
    const [phoneConfig, setPhoneConfig] = React.useState(getPhoneConfigByCountry(localStore.get('country')));
    const FW = useFieldWrapper(Object.assign(Object.assign({}, props), { clearedValue: `+${phoneConfig.iso2}` }), ref);
    const flagRef = useRef(null);
    const placeholderRef = useRef(null);
    const maskRef = useRef(null);
    const mask = phoneConfig.mask || getInitConfig().phone.defaultMask;
    const dialCode = `+${phoneConfig.dialCode} `;
    const placeholder = `${dialCode}${mask.replace(/\./g, '5')}`;
    const value = String(FW.value) || dialCode;
    const changePhoneConfig = useCallback((phoneConfig, value) => {
        localStore.set('country', phoneConfig.iso2);
        setPhoneConfig(phoneConfig);
        FW.onChange(value ? value : `+${phoneConfig.dialCode} `);
    }, []);
    useEffect(() => {
        const newPhoneConfig = getPhoneConfigByAreaCode(phoneConfig, FW.value);
        if (newPhoneConfig && phoneConfig.iso2 !== newPhoneConfig.iso2) {
            changePhoneConfig(newPhoneConfig, FW.value);
        }
    }, [FW.value]);
    useLayoutEffect(() => {
        if (flagRef.current && placeholderRef.current) {
            const left = flagRef.current.offsetWidth + 5; // margin
            placeholderRef.current.style.left = `${left}px`;
        }
    }, [flagRef.current, placeholderRef.current]);
    return (_jsx(FieldWrapper, Object.assign({ element: 'input', props: FW }, { children: _jsxs("div", Object.assign({ className: styles.container }, { children: [_jsx(PhoneInputDropdown, { iso2: phoneConfig.iso2, ref: flagRef, onClick: changePhoneConfig }), _jsxs("div", Object.assign({ ref: placeholderRef, className: styles.placeholder }, { children: [_jsx("span", Object.assign({ className: styles.placeholderHidden }, { children: value })), _jsx("span", Object.assign({ className: styles.placeholderVisible }, { children: placeholder.slice(value.length) }))] })), _jsx(IMaskInput, { ref: maskRef, mask: `${dialCode}${mask}`, definitions: { '.': /[0-9]/ }, id: FW.id.toString(), value: value, placeholder: placeholder, className: styles.input, onAccept: FW.onChange, onBeforeInput: (event) => {
                        if (event.data.startsWith('+') && event.data.length > 1) {
                            const phoneConfig = getPhoneConfigByInputValue(event.data);
                            if (phoneConfig) {
                                changePhoneConfig(phoneConfig, event.data);
                                event.preventDefault();
                            }
                        }
                    }, onKeyDown: (event) => {
                        if (event.key === 'Backspace' || event.key === 'Delete') {
                            const value = event.currentTarget.value.replace(/\D/g, '');
                            if (value === phoneConfig.dialCode) {
                                FW.onChange(dialCode);
                                event.preventDefault();
                            }
                            else if (event.currentTarget.selectionStart <= dialCode.length) {
                                event.preventDefault();
                                const selectionStart = Math.max(event.currentTarget.selectionStart, dialCode.length);
                                const selectionEnd = Math.max(event.currentTarget.selectionEnd, selectionStart);
                                if (selectionStart < selectionEnd) {
                                    FW.onChange(event.currentTarget.value.slice(0, selectionStart) +
                                        event.currentTarget.value.slice(selectionEnd));
                                }
                            }
                        }
                    } })] })) })));
});
export default observer(PhoneInput);
